import React, { useState } from 'react';
import cn from 'classnames';
import './ShoppersList.scss';

const ThreadsList = ({ threads, selectedThread, onSelect, onCreate, onDelete }) => {
  const [showCreate, setShowCreate] = useState(false);
  const [newName, setNewName] = useState('');
  const [newBio, setNewBio] = useState('');

  const handleCreate = async () => {
    if (!newName.trim()) return;
    await onCreate({ testShopperName: newName.trim(), testShopperBio: newBio.trim() || null });
    setNewName('');
    setNewBio('');
    setShowCreate(false);
  };

  return (
    <div className='shoppers-list'>
      <div className='shoppers-header'>
        <h3>Test Shoppers</h3>
        <button className='add-btn' onClick={() => setShowCreate(!showCreate)}>
          {showCreate ? '×' : '+'}
        </button>
      </div>

      {showCreate && (
        <div className='create-form'>
          <input placeholder='Name' value={newName} onChange={e => setNewName(e.target.value)} autoFocus />
          <textarea placeholder='Shopper LLM Bio (optional)' value={newBio} onChange={e => setNewBio(e.target.value)} rows={3} />
          <button onClick={handleCreate} disabled={!newName.trim()}>
            Add Shopper
          </button>
        </div>
      )}

      <div className='shoppers-scroll'>
        {threads.length === 0 ? (
          <div className='empty-state'>
            <p>No test shoppers yet</p>
            <p>Click + to add one</p>
          </div>
        ) : (
          threads.map(thread => (
            <div key={thread.id} className={cn('shopper-item', { active: selectedThread?.id === thread.id })} onClick={() => onSelect(thread)}>
              <div className='shopper-avatar'>{(thread.testShopperName || 'T').charAt(0).toUpperCase()}</div>
              <div className='shopper-info'>
                <div className='shopper-name'>{thread.testShopperName || 'Unnamed'}</div>
                <div className='shopper-bio-preview'>{thread.testShopperBio || 'No bio'}</div>
              </div>
              <button
                className='delete-btn'
                onClick={e => {
                  e.stopPropagation();
                  if (window.confirm(`Delete ${thread.testShopperName}?`)) onDelete(thread.id);
                }}
              >
                ×
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ThreadsList;
